import React from 'react';
import { Box, Button, Col, FabButton, FloatingMenu, Row, SvgIcon, theme } from '@agilize/components-core';
import { logout } from '@services/auth/Auth';
import { Link } from 'react-router-dom';
import { ChildrenStyles } from '@components/mainContainer/MainContainer.styles';
import { useIntersectionObserver } from '@utils/hooks/useIntersectionObserver';
import { useUserContext } from '@context/UserContext';
import { useLeadContext } from '@context/LeadContext';
import Helpdesk from '@components/Helpdesk/Helpdesk';
import { StyledHeader, User, HelpDeskText } from './MainHeader.styles';

interface Options {
  title: string | React.ReactNode;
  action: string;
}

const MainHeader = () => {
  const userOptions = (): Options[] => {
    const values: Options[] = [];

    if (leads.length > 1) {
      values.push({ title: 'Alternar processo ', action: 'change' });
    }
    values.push({ title: <Box color={theme.colors.red700}>Sair</Box>, action: 'logout' });
    return values;
  };
  const [ref, { isVisible: isTopOfPage }] = useIntersectionObserver({ threshold: 0, startVisible: true });
  const { user } = useUserContext();
  const { leads, setLead } = useLeadContext();
  const selectOption = (selected: string) => {
    if (selected === 'change') {
      return setLead(undefined);
    }
    return logout();
  };
  const options = userOptions();
  return (
    <>
      <div ref={ref} />
      <StyledHeader active={!isTopOfPage}>
        <ChildrenStyles>
          <Box as={Row} width="100%" noGutter>
            <Col small={8} medium={8} large={8} noGutter />
            <Col small={8} medium={8} large={8} noGutter>
              <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                <Button type="button" as={Link} to="/" variant="text">
                  <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/custom/agz.svg`} height={30} width={30} />
                </Button>
              </Box>
            </Col>
            <Col small={8} medium={8} large={8} noGutter alignSelf="center">
              <Box display="flex" alignItems="center" justifyContent="flex-end" height="100%">
                <HelpDeskText>
                  <Helpdesk>Suporte</Helpdesk>
                </HelpDeskText>

                <User>{user.name}</User>
                <FloatingMenu
                  icon={`${process.env.APP_PATH}public/assets/icons/custom/profile.svg`}
                  size="default"
                  color="information"
                  options={options}
                  itemHeight={48}
                  itemWidth={150}
                  placement="bottom-end"
                  handleOptionClick={selectOption}
                  testId="logout-button"
                  disabledBackgroundColor>
                  <FabButton
                    variant="dark"
                    color="information"
                    iconPath={`${process.env.APP_PATH}public/assets/icons/custom/profile.svg`}
                    disabledBackgroundColor
                  />
                </FloatingMenu>
              </Box>
            </Col>
          </Box>
        </ChildrenStyles>
      </StyledHeader>
    </>
  );
};

export default MainHeader;
